const COLORS = ["#09090B", "#EF4444", "#F97316", "#3B82F6", "#8B5CF6", "#0EA5E9", "#10B981"];

function hashColor(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return COLORS[Math.abs(h) % COLORS.length];
}

export const Avatar = ({ name = "?", size = 32, className = "" }) => {
  const initials = name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <div
      className={`flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${className}`}
      style={{ width: size, height: size, background: hashColor(name), fontSize: size * 0.4 }}
    >
      {initials}
    </div>
  );
};
